import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
const Cryptoicon = require('vue-cryptoicon').default;
const icons = require('vue-cryptoicon/src/icons').default;
import Vuelidate from 'vuelidate';
import VueNotifications from 'vue-notifications';
import VueMultiselect from 'vue-multiselect';
import VueMeta from 'vue-meta';
import App from './App.vue';
import router from './router';
import store from './store/index';
import i18n from './plugins/i18n';
import { options as toastOptions } from './plugins/toast';
Vue.config.productionTip = false;

Vue.use(BootstrapVue);

Cryptoicon.add(icons);
Vue.use(Cryptoicon);

Vue.use(Vuelidate);

Vue.use(VueNotifications, toastOptions);

Vue.component('vue-multiselect', VueMultiselect);

Vue.use(VueMeta);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
